import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import { Provider } from 'react-redux'
import store from './store'
import { ThemeProvider, createTheme } from '@mui/material/styles'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import DesignationScreen from './screens/DesignationScreen'
import LoginScreen from './screens/LoginScreen'
import AdminDashboardScreen from './screens/AdminDashboardScreen'
import AssociateScreen from './screens/AssociateScreen'
import DirectoryScreen from './screens/DirectoryScreen'
import ForgotPasswordScreen from './screens/ForgotPasswordScreen'
import ChangePasswordScreen from './screens/ChangePasswordScreen'
import ProfileScreen from './screens/ProfileScreen'
import OrgTreeScreen from './screens/OrgTreeScreen'

const theme = createTheme({
  palette: {
    primary: {
      main: '#F6764E',
    },
    secondary: {
      main: '#F6FAFF',
    },
  },
})

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <BrowserRouter>
            <Routes>
              {/* Public Routes */}
              <Route path='/' element={<LoginScreen />} />
              <Route path='/forgot' element={<ForgotPasswordScreen />} />
              <Route path='/change' element={<ChangePasswordScreen />} />

              {/* Protected Routes */}
              <Route path='/' element={<App />}>
                <Route path='designation' element={<DesignationScreen />} />
                <Route path='admin' element={<AdminDashboardScreen />} />
                <Route path='associates' element={<AssociateScreen />} />
                <Route path='directory' element={<DirectoryScreen />} />
                <Route path='profile' element={<ProfileScreen />} />
                <Route path='orgtree' element={<OrgTreeScreen />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </LocalizationProvider>
      </ThemeProvider>
    </Provider>
  </React.StrictMode>
)
